<template>
    <v-row class="pb-offset pt-4">
		<v-col class="pa-0 px-4">
            <v-card elevation="1" class="background-2 round-card">
                <v-tabs
					class="px-2"
                    :height="34"
                    background-color="background-2"
                    slider-color="primary">
                    <v-tab :key="1">MailUp</v-tab>

                    <v-tab-item :key="1">
                        <v-container class="background-2 pa-0 pt-2" fluid>
                            <v-row class="pb-3">
                                <v-col cols="12">
                                    <v-stepper v-model="stepIndex" vertical class="elevation-0 w100p">
                                        <v-stepper-step :complete="stepIndex > 1" step="1">
                                            <span class="body-2">Inserisci le credenziali del tuo account MailUp per procedere</span>
                                        </v-stepper-step>

                                        <v-stepper-content :complete="stepIndex > 1" step="1" v-if="!(mailup.auth && mailup.auth.access_token)">
                                            <v-card class="background-2 round-card mb-5">
												<v-container class="pa-0" fluid>
                                                    <v-row class="px-4" ref="loginform">      
                                                        <v-col cols="12">	
                                                            <v-text-field
                                                                label="Client ID"
                                                                v-model="auth.client_id"
                                                                :error-messages="errors.collect('Client ID')"
                                                                v-validate="'required'"
                                                                data-vv-name="Client ID"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col class="px-4 col-lg-6" cols="12" >
                                                            <v-text-field
                                                                label="Client secret"
                                                                v-model="auth.client_secret"
                                                                :error-messages="errors.collect('Client secret')"
                                                                v-validate="'required'"
                                                                data-vv-name="Client secret"
                                                                outlined
                                                                dense                                                          
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col class="px-4 col-lg-6" cols="12" >
                                                            <v-text-field
                                                                label="Username"
                                                                v-model="auth.username"
                                                                :error-messages="errors.collect('Username')"
                                                                v-validate="'required'"
                                                                data-vv-name="Username"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col class="px-4 col-lg-6" cols="12" >
                                                            <v-text-field
                                                                label="Password"
                                                                v-model="auth.password"
                                                                :error-messages="errors.collect('Password')"
                                                                v-validate="'required'"
                                                                data-vv-name="Password"
                                                                type="password"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
												</v-container>
                                            </v-card>
                                        <v-btn class="my-4" color="primary" @click="getLists()">Avanti</v-btn>

                                        </v-stepper-content>

                                        <v-stepper-content :complete="stepIndex > 1" step="1" v-else>
                                            <v-card color="background-1" class="my-3 pt-2 pb-3">
                                                <v-row class="px-4" ref="loginform">
                                                    <div class="body-2 px-4 pa-2 margin-auto mx-0">Sei loggato con MailUp</div>
                                                    <v-spacer></v-spacer>
                                                    <v-btn class="ma-2" color="info" @click="logout()">Logout</v-btn>
                                                    <v-btn class="ma-2" outlined
                                                    dense color="success" @click="importMailUp()">Sincronizza in Entrata</v-btn>
                                                </v-row>
                                            </v-card>
                                        </v-stepper-content>

                                        <v-stepper-step :complete="stepIndex > 2" step="2">
                                            <span class="body-2">Seleziona la lista da usare</span>
                                        </v-stepper-step>
                                        <v-stepper-content step="2">
                                            <v-col class="d-flex pa-4" cols="12" sm="6">
                                                <v-select
                                                    v-model="options.list"
                                                    :items="lists"
                                                    label="Liste"
                                                    dense
                                                    required
                                                    outlined
                                                ></v-select>
                                            </v-col>                                                
                                            <v-btn @click="stepIndex -= 1" text>Indietro</v-btn>
                                        </v-stepper-content>

                                        <v-col class="d-flex pa-4" cols="12" sm="6">
                                            <v-switch :disabled="!mailup.auth" inset class="ma-5 pl-3" v-model="mailup.active" label="Attiva" color="primary"></v-switch>
                                        </v-col>

                                    </v-stepper>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-card-actions class="background-2 pa-3">
                            <v-spacer></v-spacer>
                            <v-btn class="ma-2" :disabled="!options.list" color="primary" @click="updateStatus()">Salva</v-btn>
                        </v-card-actions>

                    </v-tab-item>

                </v-tabs>
			</v-card>

		</v-col>
		<v-snackbar
			:timeout= 6000
			color="success"
			v-model="snackbar"
			>
			<span class="fw500">{{ snackbarText }}</span>
			<v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
		</v-snackbar>
	</v-row>
</template>

<script>
    
    import Vue from 'vue'

	export default {
        name:'mail-up',
        props: {
            id: Number,
        },
		data() {
			return {
				stepIndex: 1,
				snackbar: false,
				snackbarText: '',
                mailup: {},
                options: {},
                auth: {},
                url : '',
                lists: []
			}
		},

		created() {
			this.axios.get('integrationsapps/' + this.id).then(response => {
			    // get body data
                this.mailup = response.data.data
                if(this.mailup.options == null) {
                    this.mailup.options = {}
                }
                if(this.mailup.auth == null) {
                    this.mailup.auth = {client_id: null}
                }
                this.auth = this.mailup.auth
                this.options = this.mailup.options
			   	this.$store.commit('endProgress')

			}, response => {
			    // error callback
			});
		},

		methods: {

			updateStatus() {
                Vue.set(this.mailup, 'auth', this.auth)
                Vue.set(this.mailup, 'options', this.options)
                this.axios.put('integrationsapps/' + this.id, this.mailup).then(response => {
                    // get body data
                    this.$store.commit('endProgress')
                    this.snackbar = true
				    this.snackbarText = 'Aggiornato con successo'
                    this.mailup = response.data.data.model
                    this.stepIndex = 1
                }, response => {
                    // error callback
                })
			},

			logout() {
                this.axios.get('mailuplogout/').then(response => {
                    // get body data
                    this.mailup.auth = {}
                    this.auth = {}
                }, response => {
                    // error callback
                })
            },

			getLists() {
                Vue.set(this.mailup, 'auth', this.auth)
                Vue.set(this.mailup, 'options', this.options)
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    
                    this.axios.post('mailuplists/', this.mailup).then(response => {
                        // get body data
                        this.lists = response.data.data.lists
                        this.stepIndex++
                    }, response => {
                        // error callback
                    })
                }).catch(() => {

                })
            },


			importMailUp() {
                this.axios.get('mailupimport/').then(response => {
                    // get body data
                }, response => {
                    // error callback
                })
            },
		},

		computed: {
            isLogged() {
                if(this.auth && this.auth.access_token) {
                    return true
                } else {
                    return false
                }
            }
		},
	}
</script>
